import { actions as latestEditsActions } from "components/Charts/LatestEdits/LatestEdits.reducer";
import { resourceQueryString } from "containers/AdvancedSearch/fetchAdvancedFilter";
import {
    advancedSearchFilterStorageKey,
    writeStoredFilter,
} from "containers/ExecutionFilter/filterStorage";
import { mapScreensToPaths } from "utils/RouterManager/utils";
import {
    advancedFilterResourceList,
    getFilterFieldsList,
    getFilterString,
    getSearchObj,
} from "utils/utils";

export const fetchLatestEdits = (dispatch, userData, limit) => {
    dispatch({
        type: latestEditsActions.START_FETCH_LATEST_EDITS,
        params: {
            query: resourceQueryString(),
            variables: {
                limit: limit,
                offset: 0,
                order: "-modified_at",
                filter: `{"field":"modified_by","op":"in","value":["${userData["identity_id"]}"]}`,
            },
        },
    });
};

export const buildLatestEditsQuery = (userID) => {
    // TODO CU-861m4zmq2 refactor: fix principle of least knowledge violation, indirect duplicate code issue: query build logic/details should be in one place only (and ideally should be statically checked/built from backend as the only source of truth)
    const resourceTypeField = getSearchObj({
        value: advancedFilterResourceList,
        field: "resource_type",
        op: "in",
    });
    const modifiedByField = getSearchObj({
        value: userID,
        field: "modified_by",
        op: "eq",
    });
    const filter = getFilterFieldsList(resourceTypeField);
    const customFilter = getFilterFieldsList(modifiedByField);

    writeStoredFilter(advancedSearchFilterStorageKey, {
        filter: getFilterString(filter),
        customFilter: getFilterString(customFilter),
        include_deleted: false,
        hide_deleted: true,
        tab: "resources",
        all_resource_types: true,
    });

    return mapScreensToPaths.advancedSearch;
};
